<form [formGroup]="formName">
    <h3>{{field.label}}</h3>
    <label *ngFor="let option of field.options">

        <label ngFor="let option of field.options">
            <input type="radio" [name]="field.fieldName" [formControlName]="field.fieldName" [value]="option.value">
            {{option.label}}
        </label>
    </label>
</form>